import FeedbackWrapper from "./FeedbackWrapper";

const Feedback = () => <FeedbackWrapper />;

export default Feedback;
